import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import handleUtmRedirect from '../../helpers/handleUtmRedirect';
import { LinkButton } from '../../components/buttons';
import MobileNavbarProductsButton from './components/MobileNavbarProductsButton';
import AnimatedMenuButton from '../../components/buttons/AnimatedMenuButton';
import {
  appBar,
  toolbar,
  headerStack,
  logoStyles,
  menuButton,
  drawerStyles,
  drawerContentStack,
  mobileNavbarButton,
} from './styles/mobile-navbar.styles';
import { STACK_CENTER_COLUMN_DIRECTION } from '../../constants/mui-components';

function MobileNavbar({ buttons, pages, Logo }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [barOpen, setBarOpen] = useState(false);
  const handleClick = (url) => {
    setBarOpen(false);
    if (typeof url === 'string') {
      navigate(url);
    } else {
      url();
    }
  };
  return (
    <>
      <AppBar elevation={0} sx={appBar} position="sticky">
        <Toolbar sx={toolbar}>
          <Stack sx={headerStack}>
            <Logo sx={logoStyles} />
            <Button
              id="open-sidebar-mobile"
              onClick={() => setBarOpen(!barOpen)}
              sx={menuButton}
            >
              <Tooltip title={barOpen ? 'Cerrar barra lateral' : 'Abrir barra lateral'}>
                <AnimatedMenuButton open={barOpen} />
              </Tooltip>
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
      <Drawer
        key="drawer-menu"
        anchor="top"
        onClose={() => setBarOpen(false)}
        open={barOpen}
        transitionDuration={0}
        sx={drawerStyles}
      >
        <Stack
          className={STACK_CENTER_COLUMN_DIRECTION}
          sx={drawerContentStack}
        >
          {pages.map(({ url, title, variant, ...rest }) => {
            if (variant === 'dropDown') {
              return (
                <MobileNavbarProductsButton
                  onClick={() => handleClick(url)}
                  variant={variant}
                  {...rest}
                />
              );
            }
            return (
              <LinkButton
                url={url}
                title={title.toUpperCase()}
                onClick={() => handleClick(url)}
                variant={variant}
                {...rest}
              />
            );
          })}
          {buttons.map(({ title, id, url, queryParams, ...rest }) => (
            <Grid item key={title}>
              <Button
                id={`navbar-${id}-desktop`}
                sx={mobileNavbarButton(theme)}
                onClick={() => (typeof url === 'string' ? handleUtmRedirect(url, queryParams) : url())}
                {...rest}
              >
                <Typography variant="small_3" fontWeight={600}>
                  {title}
                </Typography>
              </Button>
            </Grid>
          ))}
        </Stack>
      </Drawer>
    </>
  );
}

MobileNavbar.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  pages: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  Logo: PropTypes.node.isRequired,
};

export default MobileNavbar;
